export default "__VITE_ASSET__Db997DMC__"